export interface IMasterKey {
  masterKeyID: number;
  keyName: string | null;
  orderID: number;
  orderLockSystemID: number;
  grandMasterKeyID: number;
  numberOfKeys: number;
  colorID: number;
  engravedKey: boolean;
  keyText: string;
  addToSystem: boolean;
  addToKeyId: number;
  additionalKeys: number;

}

export default class MasterKey implements IMasterKey {
  constructor(
    public masterKeyID: number = 0,
    public keyName: string | null = null,
    public orderID: number = 0,
    public orderLockSystemID: number = 0,
    public grandMasterKeyID: number = 0,
    public numberOfKeys: number = 1,
    public colorID: number = 0,
    public engravedKey: boolean = false,
    public keyText: string = "",
    public addToSystem: boolean = false,
    public addToKeyId: number = 0,
    public additionalKeys: number = 0
  ) {}

  /**
   *
   * @param input
   * @returns
   */
  static deserialize(input: Object): MasterKey {
    return input as IMasterKey;
  }
}
